/* OPTISTASIS — fire Klaviyo's "Added to Cart" event (2026-10-08)

   Klaviyo's Shopify integration never produces this event. Placed Order and Checkout Started come
   from Shopify; Viewed Product comes from the onsite embed. Adding to cart happens entirely in the
   browser, in whatever way a theme chooses, so Klaviyo cannot hook it generically — the theme has
   to fire it. Nothing here ever did: the metric has recorded zero events since the store opened,
   while Shopify counted 270 add-to-cart sessions in the 30 days to 5 Oct 2026. Flow W4sGAe
   ("Added to cart reminder", 4h) triggers on this metric and has therefore never sent.

   This store adds to cart through several paths — fetch in optistasis-bundle-selector and
   offer-bundle-selector, XHR in custom.js and shop-cart-button-handler, a plain form POST in
   quantity-bundle-block, plus the cart upsell app — so this wraps fetch and XMLHttpRequest once
   rather than patching each caller. The form POST navigates away and is not covered; every AJAX
   path is.

   Klaviyo drops events from visitors it has not identified yet. That is expected and not a fault
   of this script: the flow can only email people it already knows.

   Nothing here can break the cart. Every hook returns the original call's result, and all of the
   tracking work sits inside try/catch. */
(function () {
  if (window.__optAtcTrack) { return; }
  window.__optAtcTrack = true;

  var ADD = /\/cart\/add(\.js)?(\?|$)/;
  var last = { id: null, at: 0 };          /* one add can trigger two listeners; 3s is plenty */

  function money(cents) {
    return typeof cents === 'number' ? Math.round(cents) / 100 : null;
  }

  function lineItem(text) {
    /* /cart/add.js answers {items:[…]} for an items[] payload, or the line item itself for a
       single id/quantity post. */
    try {
      var d = JSON.parse(text);
      if (d && d.items && d.items.length) { return d.items[0]; }
      if (d && d.id && d.product_title) { return d; }
    } catch (e) {}
    return null;
  }

  function track(added) {
    try {
      if (!added || !window.klaviyo || !window.klaviyo.push) { return; }
      var key = added.variant_id || added.id;
      var now = Date.now();
      if (key === last.id && now - last.at < 3000) { return; }
      last = { id: key, at: now };

      /* the cart read gives $value and the full basket, which is what a reminder email needs */
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart.items || []).map(function (i) {
            return {
              ProductID: i.product_id,
              VariantID: i.variant_id,
              SKU: i.sku,
              ProductName: i.product_title,
              VariantName: i.variant_title,
              Quantity: i.quantity,
              ItemPrice: money(i.price),
              RowTotal: money(i.line_price),
              ImageURL: i.image,
              URL: location.origin + (i.url || '')
            };
          });
          window.klaviyo.push(['track', 'Added to Cart', {
            $value: money(cart.total_price),
            AddedItemProductName: added.product_title,
            AddedItemProductID: added.product_id,
            AddedItemVariantID: added.variant_id,
            AddedItemVariantName: added.variant_title,
            AddedItemSKU: added.sku,
            AddedItemImageURL: added.image,
            AddedItemURL: location.origin + (added.url || ''),
            AddedItemPrice: money(added.price),
            AddedItemQuantity: added.quantity,
            ItemNames: items.map(function (i) { return i.ProductName; }),
            CheckoutURL: location.origin + '/cart',
            Items: items
          }]);
        })['catch'](function () {});
    } catch (e) {}
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var out = nativeFetch.apply(this, arguments);
      try {
        if (ADD.test(url)) {
          out.then(function (res) {
            try {
              if (res && res.ok) {
                res.clone().text().then(function (t) { track(lineItem(t)); })['catch'](function () {});
              }
            } catch (e) {}
          })['catch'](function () {});
        }
      } catch (e) {}
      return out;
    };
  }

  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__optUrl = url || ''; } catch (e) {}
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    try {
      if (ADD.test(xhr.__optUrl || '')) {
        xhr.addEventListener('load', function () {
          try {
            if (xhr.status >= 200 && xhr.status < 300) { track(lineItem(xhr.responseText)); }
          } catch (e) {}
        });
      }
    } catch (e) {}
    return send.apply(this, arguments);
  };
})();
